// extracted by mini-css-extract-plugin
export var menuMobile = "Z_fm";
export var inpSearch = "Z_l";
export var gridUpper = "Z_fn";
export var navLink = "Z_fp";
export var btn = "Z_fq";
export var rotate = "Z_c";
export var dotty = "Z_d";